import { render, staticRenderFns } from "./CreateBtn.vue?vue&type=template&id=0344ae7e&scoped=true&"
import script from "./CreateBtn.vue?vue&type=script&lang=js&"
export * from "./CreateBtn.vue?vue&type=script&lang=js&"
import style0 from "./CreateBtn.vue?vue&type=style&index=0&id=0344ae7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344ae7e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
